import React, { useEffect, useState } from 'react';
import { Leer } from '../components/hilfe/Tipp';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader2, Wallet } from 'lucide-react';
import Header from '../components/Header';
import { api } from '../context/AuthContext';
import { PortalKopf, PortalSeite, eur, datum } from '../components/portal/PortalKopf';
import { RatenBereich } from './MeineRaten';
import { PortalRechnungen } from '../components/portal/PortalRechnungen';
import { AnsichtZahlungsdaten } from '../components/portal/AnsichtZahlungsdaten';
import { Toaster } from '../components/ui/toaster';

const ZahlungenGesehen = () => { useEffect(() => { api.post('/portal/schnellstart/gesehen', { schritt: 'zahlungen' }).catch(() => {}); }, []); return null; };

const STATUS = { paid: ['bezahlt', 'bg-emerald-50 text-emerald-700'], angefordert: ['offen', 'bg-amber-50 text-amber-800'], pending: ['in Prüfung', 'bg-amber-50 text-amber-800'] };

const Akonto = ({ t }) => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get('/akonto/meine').then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, []);
  if (!items) return <div className="flex justify-center py-6"><Loader2 className="w-5 h-5 animate-spin text-[#b8893d]" /></div>;
  return (
    <section className="space-y-3" data-testid="portal-akonto">
      <h2 className="font-serif text-2xl text-[#1B3A5C]">{t('portal.vorschuesse', 'Vorschüsse')}</h2>
      {!items.length ? <Leer icon={Wallet} kompakt testId="portal-akonto-leer" titel={t('portal.keine_vorschuesse', 'Keine Vorschussanforderungen.')} text={t('portal.keine_vorschuesse_text', 'Fordert die Kanzlei einen Vorschuss an, können Sie ihn hier direkt bezahlen.')} /> : (
        <ul className="space-y-2">
          {items.map((z) => {
            const [label, cls] = STATUS[z.status] || [z.status, 'bg-gray-100 text-gray-600'];
            return (
              <li key={z.akonto_id} className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-gray-200" data-testid={`portal-akonto-${z.akonto_id}`}>
                <Wallet className="w-5 h-5 text-[#b8893d]" strokeWidth={1.75} />
                <span className="flex-1 min-w-0"><span className="block text-sm font-medium text-[#1B3A5C]">{eur(z.betrag)}</span>
                  <span className="block text-xs text-gray-500 truncate">{[z.verwendungszweck, z.aktenzeichen && `Az. ${z.aktenzeichen}`, datum(z.paid_at || z.created_at)].filter(Boolean).join(' · ')}</span></span>
                <span className={`text-[10px] tracking-wider px-2 py-1 rounded-full ${cls}`}>{t(`portal.status.${z.status}`, label)}</span>
                {z.pay_url && <Link to={z.pay_url} className="text-xs px-3 py-2 rounded-[10px] bg-[#1B3A5C] text-white hover:bg-[#2A5280]" data-testid={`portal-akonto-zahlen-${z.akonto_id}`}>{t('portal.bezahlen', 'Bezahlen')}</Link>}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};

export default function PortalZahlungen() {
  const { t } = useTranslation();
  return (
    <PortalSeite testId="portal-zahlungen">
      <ZahlungenGesehen />
      <Header />
      <main className="pt-[104px] lg:pt-[152px] pb-28">
        <PortalKopf kicker={t('portal.tab.zahlungen', 'Zahlungen')} titel={t('portal.zahlungen_titel', 'Ihre Zahlungen')} />
        <div className="max-w-3xl mx-auto px-5 mt-8 space-y-10">
          <AnsichtZahlungsdaten />
          <PortalRechnungen />
          <Akonto t={t} />
          <RatenBereich />
        </div>
      </main>
      <Toaster />
    </PortalSeite>
  );
}
